import { render, staticRenderFns } from "./BeModalPrompts.vue?vue&type=template&id=356d649a&scoped=true"
import script from "./BeModalPrompts.vue?vue&type=script&lang=js"
export * from "./BeModalPrompts.vue?vue&type=script&lang=js"
import style0 from "./BeModalPrompts.vue?vue&type=style&index=0&id=356d649a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d649a",
  null
  
)

export default component.exports